import * as React from "react";
const SvgXClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m12 4-8 8m0-8 8 8" /></svg>;
export default SvgXClose;